import React, { useState } from 'react';
export function PhoneInput({ id, allowLabel = true }) {
    const [telefone, setTelefone] = useState('');



    const handleChange = (event) => {
        const mask = (v) => {
            v = v.replace(/\D/g, '');
            if (v.length === 0) return '';
            if (v.length <= 2) return `(${v}`;
            if (v.length <= 6) return `(${v.slice(0, 2)}) ${v.slice(2)}`;
            if (v.length <= 10) return `(${v.slice(0, 2)}) ${v.slice(2, 6)}-${v.slice(6)}`;
            return `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7, 11)}`;
        };
        const { value } = event.target;
        setTelefone(mask(value));
    };

    return (
        <>
            {allowLabel && <label htmlFor={id}>Telefone (WhatsApp) *</label>}
            <input
                type="text"
                id={id}
                name={id}
                value={telefone}
                onChange={handleChange}
                onBeforeInput={(e) => {
                    if (e.data && e.data.length > 1) {
                        e.preventDefault(); // bloqueia colar ou múltiplos
                    }
                }}
                placeholder="(00) 00000-0000"
                pattern="\(\d{2}\)\s\d{5}-\d{4}"
                required
            />
        </>
    );
}